import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Grid, Heading } from '@raskrask-dk/rr-components'
import {
    FrequencyPage,
    NumberOfPeoplePage,
    StartAndEndTimePage,
    WeekdayPage,
} from './fields'
import { ProviderSteps } from '../../contexts/stepContext'
import { PropsCompanyLeadTemplate } from './props'
import { PageTemplate } from '../chemistry/skeleton'
import FinancingPage from './fields/financing'
import { StyledCompanyLead } from './styles'
import DescriptionPage from './fields/description'
import { getIsMobile } from '../../redux/reducers/appSettings'
import { useAppSelector } from '../../redux/hooks'

const CompanyLeadTemplate = ({
    canGoNext,
    goToNextState,
}: PropsCompanyLeadTemplate): ReactElement => {
    const { t } = useTranslation()

    const isMobile = useAppSelector((state) => getIsMobile(state))

    const top = (
        <Heading level={1} bold primary size={isMobile ? 3 : 1}>
            {t(`companylead.title`)}
        </Heading>
    )

    const body = (
        <StyledCompanyLead>
            <Grid gap="16">
                <ProviderSteps>
                    <FrequencyPage />
                    <WeekdayPage />
                    <NumberOfPeoplePage />
                    <StartAndEndTimePage />
                    <FinancingPage />
                    <DescriptionPage />
                    <Button
                        data-cy="companyLeadCTA"
                        disabled={!canGoNext}
                        onClick={goToNextState}
                        size="large"
                        variant="success"
                    >
                        {t('companylead.submitbutton.buttontext')}
                    </Button>
                </ProviderSteps>
            </Grid>
        </StyledCompanyLead>
    )

    return (
        <PageTemplate
            Top={
                isMobile ? (
                    <Grid gap="16">
                        {top}
                        {body}
                    </Grid>
                ) : (
                    top
                )
            }
            Body={!isMobile && body}
            Modal={undefined}
            bodyOverlap={!isMobile}
        />
    )
}

export default CompanyLeadTemplate
